module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_A_2.ec275f44.mp3";